import React from 'react';
import { minNumPlayers, maxNumPlayers, maxGameTimerMode, gameTimerModeNames } from '../../env';
import { emit, emitDebug } from '../Socket/game.Emitters';
import ToggleOption from '../Utils/ToggleOption';
import SliderOption from '../Utils/SliderOption';

export default class RoomDetails extends React.Component
{
  handleRoomSetupChange = event =>
  {
    if( event.target.name === 'max-players-limit' )
    {
      const maxPlayersLimit = Number( event.target.value );
      if( typeof maxPlayersLimit === 'number' && maxPlayersLimit >= minNumPlayers && maxPlayersLimit <= maxNumPlayers )
      {
        emit.hostChangeMaxPlayers( maxPlayersLimit );
      }
    }
  };

  onGameTimerModeReduce = ( event ) =>
  {
    // event.preventDefault();

    const gameTimerMode = this.props.options.gameTimerMode - 1;
    if( gameTimerMode >= 0 && gameTimerMode <= maxGameTimerMode )
    {
      emit.hostChangeGameSpeed( gameTimerMode );
    }
  };

  onGameTimerModeIncrease = ( event ) =>
  {
    // event.preventDefault();

    const gameTimerMode = this.props.options.gameTimerMode + 1;
    if( gameTimerMode >= 0 && gameTimerMode <= maxGameTimerMode )
    {
      emit.hostChangeGameSpeed( gameTimerMode );
    }
  };

  onMaxPlayersReduce = ( event ) =>
  {
    const maxPlayersLimit = this.props.options.maxPlayersLimit - 1;
    if( maxPlayersLimit >= minNumPlayers && maxPlayersLimit <= maxNumPlayers )
    {
      emit.hostChangeMaxPlayers( maxPlayersLimit );
    }
  };

  onMaxPlayersIncrease = ( event ) =>
  {
    const maxPlayersLimit = this.props.options.maxPlayersLimit + 1;
    if( maxPlayersLimit >= minNumPlayers && maxPlayersLimit <= maxNumPlayers )
    {
      emit.hostChangeMaxPlayers( maxPlayersLimit );
    }
  };

  startGamePressed = () =>
  {
    emit.hostToggleRoomStartGame();
  }

  render()
  {

    return (
      <div className='room-setup-room-details-panel rounded-floating-element colour-dark-accent-bg'>
        <div className="room-setup-panel-title">
          Game Settings
        </div>
        <div className='room-setup-panel-title-host'>{ this.props.isRoomHost ? "[Host]" : "" }</div>

        <div className="room-setup-room-details-room-id-section colour-dark-shade-bg">

          <div className='room-setup-room-details-game-setting-panel-title'>{ "Room ID: #" + this.props.roomID }</div>

          <div className='room-setup-room-details-invite-friends-secton'>
            <span className='room-setup-room-details-invite-friends'>Invite Friends</span>
            <input className='room-setup-room-details-invite-friends-link' type="text" defaultValue={ window.location.href } readOnly />
            <button className='room-setup-room-details-invite-friends-copy-button colour-success-bg'
              onClick={ () =>
              {
                // console.log( "Copied room URL to clipboard : " + window.location.href );

                // Copy the room URL to clipboard
                navigator.clipboard.writeText( window.location.href );
              } }>
              Copy
            </button>
          </div>
        </div>

        <div className="room-setup-room-details-private-game-section colour-dark-shade-bg">
          <div className='room-setup-room-details-game-setting-panel-title'>
            Private Game
          </div>

          <input
            type="checkbox"
            disabled={ !this.props.isRoomHost }
            checked={ this.props.options.isPrivate }
            onChange={ () => { emit.hostSetRoomPrivateState( !this.props.options.isPrivate ); } } />

        </div>

        <div className="room-setup-room-details-allow-farmers-section colour-dark-shade-bg">
          <div className='room-setup-room-details-game-setting-panel-title'>
            Allow Farmers
          </div>

          <input
            type="checkbox"
            checked={ this.props.options.farmersAllowed }
            onChange={ () => { emit.hostSetRoomAllowFarmersState( !this.props.options.farmersAllowed ); } } />

        </div>

        <div className="room-setup-room-details-game-speed-section colour-dark-shade-bg">

          <div className='room-setup-room-details-game-setting-panel-title'>
            Game Speed
          </div>

          <span className='room-setup-room-details-game-option-value'>
            { gameTimerModeNames[ this.props.options.gameTimerMode ] }
          </span>

          { this.props.isRoomHost &&
            (
              <>
                <button className='room-setup-room-details-game-option-reduce-button colour-info-bg'
                  onClick={ this.onGameTimerModeReduce }
                  disabled={ !this.props.isRoomHost }
                >
                  <img className="" src={ process.env.PUBLIC_URL + '/ui/button-arrow-left.png' } alt="Left button arrow" />
                </button>
                <button className='room-setup-room-details-game-option-increase-button colour-info-bg'
                  onClick={ this.onGameTimerModeIncrease }
                  disabled={ !this.props.isRoomHost }
                >
                  <img className="" src={ process.env.PUBLIC_URL + '/ui/button-arrow-right.png' } alt="Right button arrow" />
                </button>
              </>
            ) }
        </div>


        <div className="room-setup-room-details-max-players-section colour-dark-shade-bg">
          <div className='room-setup-room-details-game-setting-panel-title'>
            Max Players
          </div>

          <span className='room-setup-room-details-game-option-value'>
            { this.props.options.maxPlayersLimit }
          </span>

          { this.props.isRoomHost &&
            (
              <>
                <button className='room-setup-room-details-game-option-reduce-button colour-info-bg'
                  onClick={ this.onMaxPlayersReduce }
                  disabled={ !this.props.isRoomHost }
                >
                  <img className="" src={ process.env.PUBLIC_URL + '/ui/button-arrow-left.png' } alt="Left button arrow" />
                </button>

                <button className='room-setup-room-details-game-option-increase-button colour-info-bg'
                  onClick={ this.onMaxPlayersIncrease }
                  disabled={ !this.props.isRoomHost }
                >
                  <img className="" src={ process.env.PUBLIC_URL + '/ui/button-arrow-right.png' } alt="Right button arrow" />
                </button>
              </>
            ) }


        </div>


        <div className="room-setup-room-details-room-start-actions colour-dark-shade-bg">

          <div className="is-ready-toggle">
            <div className="im-ready-text">I'm Ready</div>
            <input
              type="checkbox"
              checked={ this.props.isPlayerReady }
              onChange={ () => { emit.toggleIsReadyState(); } }
            />
          </div>


          { this.props.isRoomHost &&
            (
              <button className={ this.props.areAllPlayersReady ? 'colour-success-bg' : 'colour-info-bg' } onClick={ () => { this.startGamePressed(); } }>
                Start Game
              </button>
            ) }

        </div>


        { this.props.isRoomHost &&
          this.props.options &&
          process.env.NODE_ENV !== 'production' &&
          (
            <div className='room-setup-room-details-dev-options'>

              <div className='room-setup-room-details-game-setting-panel-title'>
                Dev Mode Options
              </div>

              <br />

              <ToggleOption
                title="Skip Player Order Shuffle On Start?"
                currentState={ this.props.options.skipPlayerOrderShuffleOnStart }
                onTrueState={ () => { emitDebug.hostSkipStartShuffleTrue(); } }
                onFalseState={ () => { emitDebug.hostSkipStartShuffleFalse(); } }
              />


              <SliderOption
                title="Number of Tiles Override"
                min={ 0 }
                max={ 72 }
                value={ this.props.options.numTilesOverride ? this.props.options.numTilesOverride : 0 }
                onValueChange={ ( newValue ) => { emitDebug.hostSetTilesNumberLimit( newValue ); } }
              />

            </div>
          )
        }
      </div>
    );
  }
}
